import React from 'react'
import { TouchableOpacity } from 'react-native'

// Helpers & Services
import { buildAvatarUrl } from 'APP/Services/Mattermost'

// Styling
import { Avatar } from './style'

const MattermostAvatar = ({ id, picture, token, user, style }) => {
  const loadSource = () => {
    let url = typeof picture === 'string' ? picture : buildAvatarUrl(id)
    url = url.replace('http://', 'https://')
    return {
      uri: url,
      headers: picture ? {} : { Authorization: `Bearer ${token}` },
    }
  }

  return (
    <TouchableOpacity disabled={!user}>
      <Avatar style={style} source={loadSource()} />
    </TouchableOpacity>
  )
}

export default MattermostAvatar
